
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useEffect } from "react";
import * as Yup from 'yup';
import { IMaterial } from "../../../models/materials";
import { ITransaction, createTransactionFromMaterial } from "../../../models/transactions/transaction";
import { RootState } from "../../../redux";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { adjustMaterialInventory, resetError } from "../../../redux/slices/materials/thunks";
import { getReasons } from "../../../redux/slices/reasons";
import '../../../themes/styles.css';

interface Props {
    onCancel: () => void,
    material: IMaterial,
    error: string
}

export const MyAdjustmentForm = ({ onCancel, material, error }: Props) => {
    const dispatch = useAppDispatch();

    const { reasons = [] } = useAppSelector((state: RootState) => state.reasons);

    useEffect(() => {
        dispatch(getReasons() as any);
        dispatch(resetError());
    }, [dispatch])

    const transaction = createTransactionFromMaterial(material);

    const onSave = (transaction: ITransaction) => {
        dispatch(adjustMaterialInventory(transaction));
    }
    const { isSaved } = useAppSelector((state: RootState) => state.materials);

    useEffect(() => {
        if (isSaved)
            onCancel();
    }, [isSaved, onCancel])

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h4" component="h2">
                Inventory Adjustment
            </Typography>
            <br />
            <Typography id="modal-modal-title" variant="h6" component="h3">
                {material.name}
            </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h3">
                Available Quantity: {material.availableQuantity}
            </Typography>
            <br />
            <Divider />
            <br />
            <Formik
                initialValues={transaction}
                onSubmit={(values) => {
                    onSave(values as any);
                    //onCancel();
                }}
                validationSchema={Yup.object({
                    type: Yup.string()
                        .required('You must select an option'),
                    comment: Yup.string()
                        .required('Required'),
                    quantity: Yup.string().matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        "Only accept numbers")
                        .required('Required'),
                    workOrderId: Yup.string().matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        "Only accept numbers")
                })}
            >
                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="quantity">Quantity</Typography>
                                <Field name="quantity" type="text" />
                                {formik.errors.quantity && <div className="error-message">{formik.errors.quantity}</div>}
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="type">Type</Typography>
                                <Field component="select" name="type" placeholder="Select a Type">
                                    <option value="">
                                        Select a Type
                                    </option>
                                    <option value="in">
                                        In
                                    </option>
                                    <option value="out">
                                        Out
                                    </option>
                                </Field>
                                <ErrorMessage name="type" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="reasonId">Reason</Typography>
                                <Field component="select" name="reasonId" placeholder="Select a Type">
                                    <option value="">
                                        Select a Reason
                                    </option>
                                    {reasons.map((reason) =>
                                        <option key={reason.id} value={reason.id}>
                                            {reason.description}
                                        </option>)
                                    }
                                </Field>
                                <ErrorMessage name="reasonId" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="workOrderId">Order Number</Typography>
                                <Field name="workOrderId" type="text" />
                                <ErrorMessage name="workOrderId" component="span" className="error-message" />
                                {(error.length > 0) && <Typography component="label" htmlFor="type" className="error-message">{error}</Typography>}
                                <br />
                            </Grid>
                            <Grid item xs={12} style={{ "display": "flex", "flexDirection": "column" }}>
                                <Typography component="label" htmlFor="comment">Comment</Typography>
                                <Field name="comment" type="text" maxLength={500} rows="4" component="textarea" className="text-area" />
                                {formik.errors.comment && <div className="error-message">{formik.errors.comment}</div>}
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )
                }
            </Formik>
        </Grid >
    )
}

